import React from "react";

import InfoTooltip from "./InfoTooltip";

export default function CardHeader({
  icon,
  title,
  description,
  badge,
  iconClassName = "",
  badgeClassName = "",
  tooltipAlign = "right",
}) {
  return (
    <div className="flex items-start justify-between gap-3 overflow-visible">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-3">
          <div
            className={`flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-2xl shadow-lg ${iconClassName}`}
          >
            {icon}
          </div>

          <div className="min-w-0 flex-1">
            <h3 className="truncate text-[18px] font-bold leading-tight tracking-tight text-gray-900 dark:text-white">
              {title}
            </h3>
          </div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2 overflow-visible">
        <InfoTooltip text={description} align={tooltipAlign} />

        {badge ? (
          <span
            className={`shrink-0 rounded-full bg-black/5 px-3 py-1 text-xs font-semibold text-gray-600 dark:bg-white/10 dark:text-gray-300 ${badgeClassName}`}
          >
            {badge}
          </span>
        ) : null}
      </div>
    </div>
  );
}